import styled from 'react-emotion'

const CommentInput = styled('textarea')(({ height }) => ({
  label: 'CommentInput',
  display: 'block',
  background: 'none',
  border: 'none',
  // width: '100%',
  height,
  maxHeight: '40vh',
  overflow: 'auto',
  resize: 'none',
  lineHeight: 1.3,

  // min font size for preventing mobile browsers zooming on focus is 16
  // they are irrisposible and will leave the page zoomed after blur
  fontSize: 16,
  // we want the font size to be 14 so we have to scale down
  transform: 'scale(0.875)',
  transformOrigin: '0 0',
  // now the text area is too narrow so we have to scale width up
  width: '114.286%'
  // height is off too but it look ok and acts as a margin
  //marginBottom: space.default,
}))

export default CommentInput
